export const customerApiBase = "/sales-accounts";

export enum apiPaths {
  "fetchMe" = "/users/me",
  "quotes" = "/quotes",
  "addresses" = "/addresses",
  "settings" = "/settings",
  "companyAddresses" = "/company-addresses",
  "companyContacts" = "/company-contacts",
  "rules" = "/rules",
  "shipments" = "/shipments",
  "labelJobs" = "/label-jobs",
  "combinePdfs" = "/combine-pdfs",
  "combinePdfsBase64" = "/combine-pdfs/base64",
  "commercialInvoiceBase64" = "/combine-pdfs/commercial-invoice-base64",
  "cn22Base64" = "/combine-pdfs/cn22-base64",
  "packingSlipBase64" = "/combine-pdfs/packing-slip-base64",
  "bulkPackingSlipBase64" = "/combine-pdfs/bulk-packing-slip-base64",
  "virtualWarehouses" = "/virtual-warehouses",
  "shippingWhitelists" = "/shipping-whitelists",
  "bulkCancelShipments" = "/shipments/bulk-delete",
  "pickups" = "/pickups",
  "bulkShipments" = "/shipment-batch-jobs",
  "integrations" = "/integrations",
  "intelligence" = "/intelligence",
  "bulkShipmentsFormatValidate" = "/shipment-batch-jobs/format-validate-shipments",
  "shipmentProfiles" = "/shipment-import-profiles",
  "pusher" = "/pusher",
  "singleSalesAccount" = "/single-sales-account",
  "changelogs" = "/changelogs",
  "notifications" = "/notifications",
  "rerunShipmentRules" = "/shipments/rerun-rules",
  "supportTickets" = "/support-tickets",
  "apiKeys" = "/api-keys",
  "carrierOutageBanners" = "/carrier-outage-banners",
  "childAccounts" = "/child-accounts",
  "serviceRequests" = "/service-requests",
  "demoAccounts" = "/demo-accounts",
}

export enum apiAdminPaths {
  "salesAccounts" = "/admin/sales-accounts",
  "users" = "/admin/users",
  "carriers" = "/admin/carriers",
  "quotes" = "/admin/quotes",
  "sendQuotesEmail" = "/admin/quotes/send-email",
  "notifications" = "/admin/notifications",
  "carrierOutageBanners" = "/admin/carrier-outage-banners",
}

export enum apiPublicPaths {
  "webforms" = "/public/webforms",
  "countries" = "/public/countries",
  "currencies" = "/public/currencies",
}

export enum paths {
  "ADDRESS_BOOK_SETTINGS" = "/settings/address-book",
  "BULK_SHIPMENTS_INDEX" = "/bulk-shipments",
  "COMPANY_SETTINGS_GENERAL" = "/settings/company",
  "COMPANY_SETTINGS_DEFAULTS" = "/settings/company/defaults",
  "COMPANY_SETTINGS_SHIPPING_LANES" = "/settings/company/shipping-lanes",
  "COMPANY_SETTINGS_COMPANY_ADDRESSES" = "/settings/company/company-addresses",
  "ANALYTICS_DASHBOARD" = "/dashboard",
  "DASHBOARD_INDEX" = "/",
  "LABELS_INDEX" = "/settings/labels",
  "LOGIN_INDEX" = "/login",
  "PICKUPS_INDEX" = "/pickups",
  "PRINTING_SETTINGS" = "/settings/printing",
  "HELP_SETTINGS" = "/settings/help",
  "QUOTES_INDEX" = "/quotes",
  "RULE_SETTINGS" = "/settings/rules",
  "SETTINGS_INTEGRATIONS_INDEX" = "/settings/integrations",
  "SHIPMENTS_INDEX" = "/",
  "SHIPMENT_PROFILES_SETTINGS" = "/settings/shipment-profiles",
  "SETTINGS_VIRTUAL_WAREHOUSES_INDEX" = "/settings/virtual-warehouses",
  "USERS_SETTINGS" = "/settings/users",
  "CHILD_ACCOUNTS_SETTINGS" = "/settings/child-accounts",
  "NOTIFICATIONS_SETTINGS" = "/settings/notifications",
  "CARRIER_OUTAGE_BANNERS_SETTINGS" = "/settings/carrier-outage-banners",
  "INTELLIGENCE_INDEX" = "/intelligence",
  "EXCEPTIONS_INDEX" = "/exceptions",
  "EXCEPTIONS_V2_INDEX" = "/exceptions-v2",
  "CASES_INDEX" = "/cases",
  "SERVICES_INDEX" = "/services",
  "CHANGELOG_SETTINGS" = "/settings/changelogs",
  "DOCUMENTATIONS" = "/documentations",
}
